import { css, jsx } from '@emotion/react';
import { Badge } from '../../display/Badge/Badge.es.js';

const badgeOverrides = css({
  "& > span": {
    minWidth: "26px !important"
  }
});
function PageNavigationBadge(props) {
  return jsx(
    "span",
    { css: badgeOverrides, "data-zds": true },
    jsx(Badge, Object.assign({}, props))
  );
}

export { PageNavigationBadge as default };
//# sourceMappingURL=PageNavigationBadge.es.js.map
